export default __webpack_public_path__ + "static/media/logo-light.c0f8ff43.png";